import { filterStoreRepo } from 'components/Filters/FilterStore'
import FilterModal, {
  FilterGroup,
} from 'components/Filters/components/FilterModal'
import { DateRangeFilter } from 'components/Filters/fields/DateRangeFilter'
import {
  SelectFilter,
  SelectFilterOption,
} from 'components/Filters/fields/SelectFilter'
import { SingleSelectFilter } from 'components/Filters/fields/SingleSelectFilter'
import { FilterIdentifier } from 'models/saved_view'
import apiService from 'services/api'
import { NOTES_COLUMNS } from './notesColumnInfo'
import { useMemo } from 'react'
import { createFilterColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'

interface NotesFiltersetProps {
  filterIdentifier: FilterIdentifier
}

export default function NotesFilterset({
  filterIdentifier,
}: NotesFiltersetProps) {
  const api = apiService()
  const { data: rawUserOptions } = api.useGetUserOptions({
    onlyActive: true,
    withNoneOption: true,
  })

  const userOptions: SelectFilterOption[] | undefined = useMemo(() => {
    return rawUserOptions?.map((option) => ({
      ...option,
      value: String(option.value),
    }))
  }, [rawUserOptions])

  const notesFilterStore = filterStoreRepo.getStore(filterIdentifier)
  const notesFilterHelper = createFilterColumnHelper({
    columns: NOTES_COLUMNS,
  })

  return (
    <FilterModal store={notesFilterStore} identifier={filterIdentifier}>
      <FilterGroup title="Date Filters">
        <DateRangeFilter
          {...notesFilterHelper.retrieveProps('created')}
          filterStore={notesFilterStore}
        />
        <DateRangeFilter
          {...notesFilterHelper.retrieveProps('modified')}
          filterStore={notesFilterStore}
        />
      </FilterGroup>
      <FilterGroup title="Note Attributes">
        <SelectFilter
          {...notesFilterHelper.retrieveProps('user')}
          options={userOptions || []}
          filterStore={notesFilterStore}
        />
        <SingleSelectFilter
          title={NOTES_COLUMNS.attachments.header}
          filterKey="has_attachment"
          options={[
            { value: 'true', label: 'Yes' },
            { value: 'false', label: 'No' },
          ]}
          filterStore={notesFilterStore}
          hideSearch
        />
      </FilterGroup>
    </FilterModal>
  )
}
